import {EnvironmentalClaimType, Nullable} from "../../definitions/types";
import {EnvironmentalClaimModel} from "../domain/environmentalClaimModel";

export class EnvironmentalModel {
    private readonly _isConscious: boolean;
    private readonly _score: number;
    private readonly _claims: EnvironmentalClaimModel[];

    constructor(data: Nullable<{ isConscious: boolean; score: number, claims: EnvironmentalClaimType[] }>) {
        this._isConscious = data?.isConscious ?? false;
        this._score = data?.score ?? 0;
        this._claims = (data?.claims ?? []).map(claim => new EnvironmentalClaimModel(claim));
    }

    public get isConscious(): boolean {
        return this._isConscious;
    }

    public get score(): number {
        return this._score;
    }

    public get claims(): EnvironmentalClaimModel[] {
        return this._claims;
    }
}